<div [formGroup]="ContactForm" class="d-flex flex-column gap-15">
    <!-- <h4 class="d-flex align-items-center justify-content-start contact-title">
        <img src="../../../../../assets/icons/new-service-user.svg" alt="User icon" />
        {{ 'pickupContact' | translate }}
    </h4> -->
    <div *ngIf="ShowExternalContainer" class="d-flex flex-column data-box w-100"
        [ngClass]="{'data-box-disabled': disableCorporativeBoxContact}">
        <div [ngClass]="{
            checked:
            ContactForm.get('IsContactParticular')?.value ===
              false,
            'error-input':
            ContactForm &&
            ContactForm.get('IsContactParticular')?.invalid,
            'disabled-contact-selector': disableCorporativeContact,
          }" (click)="selectOption(false)" (keydown)="selectOption(false)" tabindex="0"
            class="contact-selector d-flex flex-column align-items-start justify-content-center">
            <input type="radio" (click)="selectOption(false)" [checked]="ContactForm.get('IsContactParticular')?.value ===
              false" id="pickup-contact-same-person" />
            <div class="contact-text">
                <label>{{ 'corporate_contact' | translate }}</label>
                <span>{{ 'corporate_contact_description' | translate }}</span>
            </div>
        </div>
        <div *ngIf="
            ContactForm.get('IsContactParticular')?.invalid &&
            ContactForm
          " class="error">
            {{ 'required' | translate }}
        </div>
    </div>
    <div *ngIf="ShowExternalContainer" class="d-flex flex-column data-box w-100"
        [ngClass]="{'data-box-disabled': disableParticularBoxContact}">
        <div [ngClass]="{
            checked:
            ContactForm.get('IsContactParticular')?.value ===
              true,
            'error-input':
            ContactForm &&
            ContactForm.get('IsContactParticular')?.invalid,
            'disabled-contact-selector': disableParticularContact,
          }" (click)="selectOption(true)" (keydown)="selectOption(true)" tabindex="0"
            class="contact-selector d-flex flex-column align-items-start justify-content-center">
            <input type="radio" (click)="selectOption(true)"
                [checked]="ContactForm.get('IsContactParticular')?.value === true" id="pickup-contact-same-person" />
            <div class="contact-text">
                <label>{{ 'particular_contact' | translate }}</label>
                <span>{{ 'particular_contact_description' | translate }}</span>
            </div>
        </div>
        <div *ngIf="
            ContactForm.get('IsContactParticular')?.invalid" class="error">
            {{ 'required' | translate }}
        </div>
    </div>
    <div class="two-blocks-row">
        <div class="data-box">
            <label for="pickup-contact-name">{{ 'firstName' | translate }}</label>
            <input type="text" name="pickup-contact-name" formControlName="Name" placeholder="Dani" required [ngClass]="{
            'error-input':
            ContactForm &&
            ContactForm.get('Name')?.touched && 
              !ContactForm.get('Name')?.valid,
          }" />
            <div *ngIf="ContactForm.get('Name')?.touched &&
            ContactForm.get('Name')?.invalid" class="error">
                {{ 'required' | translate }}
            </div>
        </div>
        <div class="data-box">
            <label for="pickup-contact-lastname">{{ 'last_name' | translate }}</label>
            <input type="text" name="pickup-contact-lastname" formControlName="LastName" placeholder="Parrales Rosa"
                [ngClass]="{
            'error-input':
            ContactForm && 
            ContactForm.get('LastName')?.touched &&
              !ContactForm.get('LastName')?.valid,
          }" />
            <div *ngIf=" ContactForm.get('LastName')?.touched &&
            ContactForm.get('LastName')?.invalid" class="error">
                {{ 'required' | translate }}
            </div>
        </div>
    </div>
    <div class="phone-box d-flex flex-column align-items-start">
        <label for="pickup-contact-phone">{{ 'mobile_number' | translate }}</label>
        <div class="form-group w-100 d-flex flex-column data-box">
            <app-phone-number-input [phoneNumber]="ContactForm.get('PhoneNumber')?.value"
                (phoneChange)="onOriginPhoneNumberChange($event)"></app-phone-number-input>
        </div>
        <div *ngIf="
          ContactForm.get('PhoneNumber')?.invalid" class="error">

        </div>
        <div class="data-box d-flex flex-column align-items-start align-self-stretch w-100">
            <label for="user-mail" class="user-mail-origin-and-destiny">{{ 'email_address_title' | translate }}
                <small *ngIf="ShowEmailOptional" style="font-weight: 500;">({{ 'optional' | translate
                    }})</small></label>
            <input id="user-mail" class="default-input" type="text" formControlName="Email"
                placeholder="email@email.com" autocomplete="on" />
        </div>
    </div>

</div>